const orderSi = {
    "total": "Skupaj",
    "order_successfully_placed": "Naročilo oddano",
    "empty_cart": "Vaša košarica je trenutno prazna",
    "place_order": "Oddajte naročilo",
    "i_order": "Oddajte naročilo",
    "order_confirmation": "Potrditev naročila",
    "order_confirmation_msg_raw": "Z oddajo naročila sprejemate naše pogoje uporabe in našo politiko zasebnosti, ki jo najdete na <a href=\":link\" class=\"generated-link\" target=\"_blank\">spodnji povezavi</a>.",
    "status_PLACED": "Postavljeno",
    "status_ACCEPTED": "Sprejeto",
    "status_SERVED": "Postreženo",
    "status_PAID": "Plačano",
    "empty_pending_orders": "Trenutno nimate čakajočih naročil",
    "overview": "Pregled naročila",
    "note": "Opomba",
    "items": "Predmeti",
    "review_order": "Pregled"
};

export default orderSi;
